import Small from 'UIComponents/elements/Small';
import { HIDDEN } from 'customer-data-objects/property/AccessLevel';
import { isDate, isDateTime } from 'customer-data-objects/property/PropertyIdentifier';
import { useAccessLevel } from 'customer-data-properties/accessLevel/AccessLevelContext';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import UIFlex from 'UIComponents/layout/UIFlex';
import TableCellWithoutPropertyDefinition from 'framework-listing-lib/internal/Table/components/TableCellWithoutPropertyDefinition';
import { TimeZoneTooltipWithoutInlineEdit } from 'framework-listing-lib/internal/Table/components/TimeZoneTooltip';
import { useTableColumn } from 'framework-listing-lib/internal/Table/providers/TableColumnsProvider';
import ListingLibTruncateDiv from 'framework-listing-lib/table/ListingLibTruncateDiv';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Get the correct date format based on @formatCellAs.
 * Default to "datetime" when not defined.
 */
function getDateTimeFormat(formatCellAs) {
  if (!formatCellAs) {
    return 'LL';
  }
  switch (formatCellAs) {
    default:
    case 'datetime':
    case 'date':
      return 'LL';
    case 'time':
      return 'LT';
  }
}
function getFormatCellAs({
  formatCellAs,
  propertyDefinition
}) {
  if (formatCellAs) {
    return formatCellAs;
  } else if (isDateTime(propertyDefinition)) {
    return 'datetime';
  } else if (isDate(propertyDefinition)) {
    return 'date';
  }
  return undefined;
}
function DateTimeValue({
  crmObject,
  formatCellAs,
  propertyDefinition,
  value,
  getSecondaryPropertyValue
}) {
  return /*#__PURE__*/_jsx(FormattedPropertyV2, {
    "data-test-id": "crm-listing-table-cell",
    "data-test-format": formatCellAs,
    dateTimeFormat: getDateTimeFormat(formatCellAs),
    dateFormat: formatCellAs === 'date' ? getDateTimeFormat(formatCellAs) : undefined,
    getAdditionalPropertyValue: getSecondaryPropertyValue,
    objectId: String(crmObject.objectId),
    objectTypeId: crmObject.objectTypeId,
    property: propertyDefinition,
    value: value
  });
}
export default function ListingLibDateTimeCell({
  crmObject,
  propertyName,
  value,
  getSecondaryPropertyValue
}) {
  const column = useTableColumn(propertyName);
  const accessLevel = useAccessLevel({
    objectType: crmObject.objectTypeId,
    propertyName
  });
  if (!column || !column.propertyDescriptor) {
    return /*#__PURE__*/_jsx(TableCellWithoutPropertyDefinition, {
      value: value
    });
  }
  const formatCellAs = getFormatCellAs({
    formatCellAs: column.formatCellAs,
    propertyDefinition: column.propertyDescriptor
  });
  const propertyWithRelativeTime = column.propertyDescriptor.dateDisplayHint === 'absolute_with_relative' || column.propertyDescriptor.dateDisplayHint === 'time_since' || column.propertyDescriptor.dateDisplayHint === 'time_until';
  return /*#__PURE__*/_jsx(ListingLibTruncateDiv, {
    children: /*#__PURE__*/_jsx(TimeZoneTooltipWithoutInlineEdit, {
      value: value,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(DateTimeValue, {
          crmObject: crmObject,
          formatCellAs: formatCellAs,
          propertyDefinition: column.propertyDescriptor,
          value: value,
          getSecondaryPropertyValue: getSecondaryPropertyValue
        }), formatCellAs === 'datetime' && value && accessLevel !== HIDDEN && !propertyWithRelativeTime && /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(DateTimeValue, {
            crmObject: crmObject,
            formatCellAs: "time",
            propertyDefinition: column.propertyDescriptor,
            value: value,
            getSecondaryPropertyValue: getSecondaryPropertyValue
          })
        })]
      })
    })
  });
}